<template>
  <keep-alive>
    <router-view/>
  </keep-alive>
</template>

<script>
  export default {
    name: 'Counter'
  }
</script>

<style scoped>

</style>